export function chapterTitles(source) {
	const obj = {
		title: null, 
		subtitles: []
	};

	try {
		const chapterContent = require(`../../data/${source}`);
		const { meta, content } = chapterContent;
		obj.title = meta.title;

		if (content) {
			content.forEach((row) => {
				if (row.subTitle) {
					obj.subtitles.push(row.subTitle);
				}
			});
		}
	} catch (e) {
		throw new Error(e);
	}

	return obj;
}

export function chapterSource(source) {
	let obj = {};

	try {
		const chapterContent = require(`../../data/${source}`);
		obj = chapterContent;
	} catch (e) {
		throw new Error(e);
	}

	return obj;
}

export function getChartData() {
	
}